// 채팅 페이지 런타임 턴 모델 — 바닐라 addUserMessage/addAgentMessage 의 DOM 구조를
// 데이터로 옮긴 것. MessageList 가 이 모델을 바닐라와 동일한 클래스 마크업으로
// 렌더하고, 그 innerHTML 이 스냅샷 messagesHtml 이 된다 (양방향 호환).

export interface ProgressLine {
  kind: "spin" | "tool" | "ok" | "plain";
  text: string;
}

export interface ProgressState {
  /** 이전 단계 — '이전 단계 보기 (n개)' 토글 뒤로 접힌다 */
  history: ProgressLine[];
  current: ProgressLine | null;
  open: boolean;
  /** 응답 종료 후 — 스피너 제거·완료형 문구 반영됨 */
  finalized: boolean;
}

export type FlowItem =
  | { kind: "text"; html: string }
  | { kind: "art"; className: string; html: string; attrs?: Record<string, string> }
  | { kind: "chart"; spec: unknown };

export interface UserTurn {
  role: "user";
  time: string;
  text: string;
  files?: string[];
}

export interface AgentTurn {
  role: "agent";
  time: string;
  /** 턴 시작 시각(ms) — 실행 중 경과 표시·완료 후 총 소요 계산용 */
  startedAt?: number;
  /** 아직 응답 진행 중 (로고 로딩 애니메이션) */
  live: boolean;
  /** 스트리밍 조각 상태 — 대화별 동시 스트림을 위해 전역 ref 에서 턴으로 옮김 */
  segIdx?: number | null;
  buf?: string;
  /** token 스트리밍 수신 중 (스피너 숨김) */
  streaming: boolean;
  progress: ProgressState;
  /** 텍스트·아티팩트가 도착한 순서대로 쌓인다 (바닐라 data-flow) */
  flow: FlowItem[];
  /** 맨 아래 고정 영역 (바닐라 data-arts): 다운로드 버튼 */
  downloads: Array<{ html: string; quiet?: boolean }>;
  /** 되묻기 — 골라야 진행 */
  choices: string[] | null;
  /** 꼬리 질문 — 답변 완료 후에만 렌더 */
  next: string[];
  nextFinal: boolean;
}

export type ChatTurn = UserTurn | AgentTurn;

/** 경과·소요 시간 표기 — 65_000ms → "1분 5초" */
export function fmtElapsed(msec: number): string {
  const s = Math.max(0, Math.floor(msec / 1000));
  return s >= 60 ? `${Math.floor(s / 60)}분 ${s % 60}초` : `${s}초`;
}

export function newAgentTurn(): AgentTurn {
  return {
    role: "agent",
    time: "",
    startedAt: Date.now(),
    live: true,
    streaming: false,
    progress: { history: [], current: null, open: false, finalized: false },
    flow: [],
    downloads: [],
    choices: null,
    next: [],
    nextFinal: false,
  };
}
